import React, { useState } from 'react';
import { Box, Button, Collapse, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { tokens } from '../theme/tokens';
import {
  ErpSyncFieldChange,
  formatFieldChangeName,
  formatFieldChangeValue,
} from '../utils/erpSyncAuditDisplay';

/**
 * Expandable "What changed" list for one sync audit event (flag `sync_audit_field_history`).
 * Renders nothing when the event carries no field changes.
 */
export function ErpSyncFieldChanges({ changes }: { changes?: ErpSyncFieldChange[] | null }) {
  const [open, setOpen] = useState(false);
  if (!changes || changes.length === 0) return null;
  return (
    <Box sx={{ mt: 0.5 }}>
      <Button
        size="small"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.75rem', px: 0.5, minWidth: 0 }}
      >
        What changed ({changes.length})
      </Button>
      <Collapse in={open} unmountOnExit>
        <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {changes.map((change) => (
            <Box component="li" key={change.field} sx={{ minWidth: 0 }}>
              <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.primary', display: 'block' }}>
                {formatFieldChangeName(change.field)}
              </Typography>
              <Typography variant="caption" sx={{ color: tokens.ink.muted, overflowWrap: 'anywhere' }}>
                {formatFieldChangeValue(change.before)} → {formatFieldChangeValue(change.after)}
              </Typography>
            </Box>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
